<script>
import { BDropdownText } from "bootstrap-vue";

export default {
  extends: BDropdownText
};
</script>